var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgCreditCard1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.131,
    height: 21.261,
    viewBox: "0 0 26.131 21.261",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M24.824,51.141H22.316l-.7-5.311a1.317,1.317,0,0,0-1.47-1.122L1.135,47.227a1.308,1.308,0,0,0-.867.5,1.294,1.294,0,0,0-.256.966l1.6,12.1A1.3,1.3,0,0,0,3.081,61.92l1.259-.166v2.9a1.307,1.307,0,0,0,1.307,1.307H24.824a1.307,1.307,0,0,0,1.307-1.307v-12.2A1.307,1.307,0,0,0,24.824,51.141Zm-3.387,0h-3.4l3.344-.443ZM.875,48.58a.427.427,0,0,1,.086-.319.436.436,0,0,1,.29-.17l19-2.518a.442.442,0,0,1,.493.375l.172,1.3L1.047,49.881ZM4.34,60.875l-1.371.181a.436.436,0,0,1-.489-.375h0l-.972-7.347,2.833-.374Zm.058-8.8-3.007.4-.229-1.724,19.873-2.636.131,1,.1.726L11.4,51.141H5.648A1.308,1.308,0,0,0,4.4,52.073ZM25.26,64.652a.436.436,0,0,1-.436.436H5.648a.436.436,0,0,1-.436-.436V52.462s0-.009,0-.013a.436.436,0,0,1,.436-.436H24.824a.436.436,0,0,1,.436.436Z",
    transform: "translate(0 -44.698)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M290.965,214.911a2.179,2.179,0,0,0,.459-.459,2.179,2.179,0,1,0,0-2.588,2.179,2.179,0,1,0-.459,3.047Zm2.2-3.061a1.307,1.307,0,1,1-1.307,1.307A1.307,1.307,0,0,1,293.167,211.85Zm-3.487,0a1.307,1.307,0,1,1-1.307,1.307A1.307,1.307,0,0,1,289.681,211.85Z",
    transform: "translate(-271.83 -201.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 0.872,
    height: 0.872,
    transform: "translate(6.956 9.494)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 5.23,
    height: 0.872,
    transform: "translate(8.699 9.494)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 6.973,
    height: 0.872,
    transform: "translate(6.956 11.238)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M143.8,322.981H128.115a.436.436,0,0,0-.436.436v2.615a.436.436,0,0,0,.436.436H143.8a.436.436,0,0,0,.436-.436v-2.615A.436.436,0,0,0,143.8,322.981Zm-.436,2.615H128.551v-1.743h14.818Z",
    transform: "translate(-120.723 -307.821)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard1);
export default __webpack_public_path__ + "static/media/credit-card (1).1330dbe4a329be9b8f79f40bc70b87ef.svg";
export { ForwardRef as ReactComponent };